import styled from '@emotion/styled';

import colors from '$variables/colors';
import { typography, spacing } from '$variables/theme';

export const Container = styled.div`
  width: 100%;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const Column = styled.div`
  padding-top: 22px;
`;

// 262px is left column width
// 113px is right column width
export const AssignmentsGradesColumn = styled.div`
  flex-grow: 1;
  max-width: calc(100% - 262px - 113px);
  ${({ totalAssignments }) =>
    totalAssignments > 3 &&
    `
    overflow-x: scroll;
    box-shadow: inset 4px 0px 4px -4px rgba(0,0,0,0.2), inset -4px 0px 4px -4px rgba(0,0,0,0.2);
  `}
`;

export const AssignmentsColumn = styled.div`
  display: flex;
  flex-direction: row;
  padding-left: ${spacing.xSmall};
  padding-right: ${spacing.xSmall};
`;

export const AssignmentColumn = styled.div``;

export const Header = styled.div`
  font-weight: ${typography.fontWeightSemiBold};
  white-space: nowrap;
  height: 42px;
`;

export const HeaderRight = styled(Header)`
  padding-left: ${spacing.small};
`;

export const Separator = styled.div`
  height: 1px;
  background-color: ${colors.border1};
  width: 888px;
  position: absolute;
`;
